import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mss-create-folder',
  templateUrl: './mss-create-folder.component.html',
  styleUrls: [
    './mss-create-folder.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class MssCreateFolderComponent implements OnInit, AfterViewInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public validButtonLabel = 'Créer';

  public closeEmitter = new EventEmitter();
  public formGroup: FormGroup;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      folderName: ['', Validators.required]
    });
  }

  ngAfterViewInit(): void {
    const input = document.querySelector('input#folderName');
    setTimeout(() => {
      if (input) {
        (input as HTMLElement).focus();
      }
    }, 0);
  }

  public validFolderName(): void {
    if (!this.formGroup.valid) {
      return;
    }
    const folderName = this.formGroup.get('folderName').value;
    folderName && folderName !== '' ? this.closeModal(folderName) : this.closeModal();
  }

  public closeModal(folderName?: string): void {
    this.closeEmitter.emit(folderName);
  }

}
